import GameType from "../data/GameType";
import md5 from 'crypto-js/md5';

const NumbersUtil = {
    createAvailable: (max) => {
        var result = [];
        for (var i = 1; i <= max; i++) {
            result.push(i);
        }
        return result;
    },
    getNumber: (max, available) => {
        var result;
        while (!result) {
            var i = Math.floor(Math.random() * max)
            result = available[i];
        }
        delete available[available.indexOf(result)];
        return result;
    },
    getNumbers: (count, max) => {
        var result = [];
        var available = NumbersUtil.createAvailable(max);
        for (var i = 0; i < count; i ++) {
            result.push(NumbersUtil.getNumber(max,available));
        }
        return result;
    },
    randomBingo: () => {
        var result = [];
        for (var i = 0; i < 5; i++) {
            var column = NumbersUtil.getNumbers(5, 15);
            // eslint-disable-next-line no-loop-func
            column = column.map((nr) => nr + i*15);
            result.push(column);
        }
        var row = GameType.BINGO.emptyRow();
        row.numbers = result;
        return row;
    },
    randomKeno: (count) => {
        var result = {main: NumbersUtil.sort(NumbersUtil.getNumbers(count, GameType.KENO.mainNumbers[1]))};
        return result;
    },
    randomRow: (gameType) => {
        var result = {};
        result.main = NumbersUtil.sort(NumbersUtil.getNumbers(gameType.mainMax, gameType.mainNumbers[1]));
        result.extra = NumbersUtil.sort(NumbersUtil.getNumbers(gameType.extraMax, gameType.extraNumbers[1]));
        return result;
    },
    sort: (numbers) => {
        numbers.sort((a,b) => {return a - b});//because js otherwise sorts numbers alphabetically
        return numbers;
    },
    rowFilled: (row, min) => {
        // eslint-disable-next-line valid-typeof
        return row.length >= min && row.every((nr) => typeof nr !== "undefined" && typeof nr !== "null")
    },
    allRowsFilled: (rows, gameType) => {
        if (gameType === GameType.KENO) {
            return rows.every((row) => NumbersUtil.rowFilled(row.main, gameType.mainMin));
        }
        if (gameType === GameType.BINGO) {
            var res = NumbersUtil.allBingoRowsFilled(rows);
            //console.log(res);
            return res;
        }
        var result = rows.every((row) => NumbersUtil.rowFilled(row.main, gameType.mainMin)) 
        && rows.every((row) => NumbersUtil.rowFilled(row.extra, gameType.extraMin));
        return result;
    },
    allBingoRowsFilled: (rows) => {
        return rows.every((row) => {
            return row.numbers.every((numbers) => {
                return numbers.length === 5 && numbers.every((number) => {
                    return typeof number === 'number';
                });
            });
        });
    },
    padPrice: (price) => {
        price = price + '';
        if (price.includes('.') && price.substring(price.indexOf('.').length < 3)) {
            price += '0';
        } else if (!price.includes('.')) {
            price += '.00';
        }
        return price + ' €';
    },
    getQRString: (cart) => {
        var result = '';
        Object.entries(cart).forEach((entry) => {
            var gt = GameType.getGameType(entry[0]);
            var game = entry[1];
            var rows = game.rows;
            result += gt.name.substring(0,1) + ":" + game.drawCount + ":" + game.stake + ":";
            if (gt === GameType.BINGO) {
                result += NumbersUtil.getBingoQRString(game);
            } else {
                rows.forEach((row, i) => {
                    row.main.forEach((nr) => {result += '#' + nr});
                    if (row.extra) {
                        row.extra.forEach((nr) => {result += '&' + nr});
                    }
                    if (i !== rows.length -1) {
                        result += ',';
                    }
                });
            }
            result += ';';
        });
        result += '.';
        result += md5(result);
        //console.log(result);
        return result;
    },
    getBingoQRString: (game) => {
        var result = '';
        game.rows.forEach((row, rowNr) => {
            row.numbers.forEach((column, colNr) => {
                column.forEach((nr, i) => {
                    nr = nr < 10 ? '0' + nr : nr;
                    if (NumbersUtil.isBingoCorner(colNr, i)) {
                        result += '[' + nr;
                    } else if (NumbersUtil.isBingoDiagonal(colNr, i)) {
                        result += '/' + nr;
                    } else {
                        result += '#' + nr;
                    }
                });
            });
            if (rowNr !== game.rows.length -1) {
                result += ',';
            }
        });
        return result;
    },
    isBingoCorner: (colNr, i) => {
        return (colNr === 0 || colNr === 4) && (i === 0 || i === 4);
    },
    isBingoDiagonal: (colNr, i) => {
        return ((colNr === 1 || colNr === 3) && (i === 1 || i === 3)) || (colNr === 2 && i ===2);
    }
}
export default NumbersUtil;